module.exports = __webpack_public_path__ + "static/index/img/baikal-1000.b2bc55ab.jpg";